export const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import('/Users/hail/work/base/apps/tms/src/pages/index.vue'),
    children: [
      {
        path: 'inbox',
        /* internal name: '//inbox' */
        /* no component */
        children: [
          {
            path: '',
            name: 'inbox',
            component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/inbox/index.vue'),
            /* no children */
            meta: {
              "breadcrumb": "Inbox",
              "layout": "Sidebar"
            }
          }
        ],
      },
      {
        path: 'linguists',
        /* internal name: '//linguists' */
        /* no component */
        children: [
          {
            path: '',
            name: 'linguists',
            component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/linguists/index.vue'),
            /* no children */
            meta: {
              "breadcrumb": "Linguists",
              "layout": "Sidebar"
            }
          }
        ],
      },
      {
        path: 'orders',
        /* internal name: '//orders' */
        /* no component */
        children: [
          {
            path: '',
            name: 'orders',
            component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/orders/index.vue'),
            /* no children */
            meta: {
              "breadcrumb": "Orders",
              "layout": "Sidebar"
            }
          },
          {
            path: ':orderId',
            /* internal name: '//orders/[orderId]' */
            /* no component */
            children: [
              {
                path: '',
                name: 'orders-detail',
                component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/orders/[orderId]/index.vue'),
                /* no children */
                meta: {
                  "breadcrumb": "Orders Detail",
                  "layout": "Sidebar"
                }
              },
              {
                path: 'auto-quotation',
                name: 'auto-quotation',
                component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/orders/[orderId]/auto-quotation.vue'),
                /* no children */
                meta: {
                  "breadcrumb": "Auto Quotation",
                  "layout": "Sidebar"
                }
              },
              {
                path: 'manual-quotation',
                name: 'manual-quotation',
                component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/orders/[orderId]/manual-quotation.vue'),
                /* no children */
                meta: {
                  "breadcrumb": "Manual Quotation",
                  "layout": "Sidebar"
                }
              }
            ],
          },
          {
            path: 'preview',
            /* internal name: '//orders/preview' */
            /* no component */
            children: [
              {
                path: ':snapshotId',
                name: 'preview-contents',
                component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/orders/preview/[snapshotId].vue'),
                /* no children */
                meta: {
                  "breadcrumb": "Preview",
                  "layout": "Sidebar"
                }
              }
            ],
          }
        ],
      },
      {
        path: 'pricing',
        /* internal name: '//pricing' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pricing',
            component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/pricing/index.vue'),
            /* no children */
            meta: {
              "breadcrumb": "Pricing",
              "layout": "Sidebar"
            }
          }
        ],
      },
      {
        path: 'projects',
        /* internal name: '//projects' */
        /* no component */
        children: [
          {
            path: '',
            name: 'projects',
            component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/projects/index.vue'),
            /* no children */
            meta: {
              "breadcrumb": "Projects",
              "layout": "Sidebar"
            }
          },
          {
            path: ':projectId',
            name: 'projects-detail',
            component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/projects/[projectId].vue'),
            /* no children */
            meta: {
              "breadcrumb": "Projects Detail",
              "layout": "Sidebar"
            }
          }
        ],
      },
      {
        path: 'tasks',
        /* internal name: '//tasks' */
        /* no component */
        children: [
          {
            path: '',
            name: 'tasks',
            component: () => import('/Users/hail/work/base/apps/tms/src/pages/index/tasks/index.vue'),
            /* no children */
            meta: {
              "breadcrumb": "Tasks",
              "layout": "Sidebar"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/Users/hail/work/base/apps/tms/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('/Users/hail/work/base/apps/tms/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/oauth-callback',
    name: '/oauth-callback',
    component: () => import('/Users/hail/work/base/apps/tms/src/pages/oauth-callback.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

